var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { connect, mapProps, h, mapReadPretty } from '@formily/vue';
import { defineComponent } from '@vue/composition-api';
import { composeExport, transformComponent, resolveComponent, } from '../__builtins__/shared';
import { Checkbox as VanCheckbox, CheckboxGroup as VanCheckboxGroup, } from 'vant';
import { PreviewText } from '../preview-text';
var TransformVanCheckbox = transformComponent(VanCheckbox, {
    change: 'input',
});
var CheckboxOption = defineComponent({
    name: 'FCheckboxOption',
    inheritAttrs: false,
    props: {
        option: {
            type: Object,
            default: null,
        },
    },
    setup: function (customProps, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        return function () {
            var props = attrs;
            var option = customProps === null || customProps === void 0 ? void 0 : customProps.option;
            if (option) {
                var children = {
                    default: function () {
                        var _a;
                        return [
                            resolveComponent((_a = slots.default) !== null && _a !== void 0 ? _a : option.label, { option: option }),
                        ];
                    },
                };
                var newProps = {};
                Object.assign(newProps, option);
                newProps.label = option.value;
                delete newProps.value;
                return h(VanCheckbox, {
                    attrs: __assign({}, newProps),
                }, children);
            }
            return h(TransformVanCheckbox, {
                attrs: __assign({}, props),
                on: listeners,
            }, {
                default: function () { return [props.label]; },
            });
        };
    },
});
var TransformVanCheckboxGroup = transformComponent(VanCheckboxGroup, {
    change: 'input',
});
var CheckboxGroupOption = defineComponent({
    name: 'FCheckboxGroupOption',
    props: {
        options: {
            type: Array,
            default: function () { return []; },
        },
    },
    setup: function (customProps, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        return function () {
            var options = customProps.options || [];
            var children = options.length !== 0
                ? {
                    default: function () {
                        return options.map(function (option) {
                            if (typeof option === 'string') {
                                return h(Checkbox, {
                                    props: {
                                        option: {
                                            label: option,
                                            name: option,
                                        },
                                    },
                                }, (slots === null || slots === void 0 ? void 0 : slots.option)
                                    ? { default: function () { return slots.option({ option: option }); } }
                                    : {});
                            }
                            else {
                                return h(Checkbox, {
                                    props: {
                                        option: option,
                                    },
                                }, (slots === null || slots === void 0 ? void 0 : slots.option)
                                    ? { default: function () { return slots.option({ option: option }); } }
                                    : {});
                            }
                        });
                    },
                }
                : slots;
            return h(TransformVanCheckboxGroup, {
                attrs: __assign({}, attrs),
                on: listeners,
            }, children);
        };
    },
});
var CheckboxGroup = connect(CheckboxGroupOption, mapProps({ dataSource: 'options' }), mapReadPretty(PreviewText.Checkbox, {
    multiple: true,
}));
export var Checkbox = composeExport(connect(CheckboxOption), {
    Group: CheckboxGroup,
});
export default Checkbox;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/checkbox/index.js
// module id = null
// module chunks = 